import posthog from "posthog-js";

const POSTHOG_KEY = "phc_qPG6FKfqdfVFFk77GGRTnsV9fMN2oMsFFWz5iLPiGZUg";
const POSTHOG_HOST = "https://eu.i.posthog.com";

let initialised = false;

export function initPostHog() {
  if (initialised || typeof window === "undefined") return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: true, // No screen recording — privacy first
    persistence: "localStorage+cookie",
    loaded: (ph) => {
      if (import.meta.env.DEV) {
        ph.opt_out_capturing(); // Don't track in dev
      }
    },
  });
  initialised = true;
}

/**
 * Identify user after login — NO PII sent.
 * Only user ID, role, and firm ID for segmentation.
 */
export function identifyUser(
  userId: string,
  properties: { role?: string; workspaceId?: string; email?: string | null } = {},
) {
  if (!initialised) return;
  posthog.identify(userId, {
    role: properties.role || "unknown",
    workspace_id: properties.workspaceId || "unknown",
  });
}

/** Reset identity on logout */
export function resetPostHog() {
  if (!initialised) return;
  posthog.reset();
}

/** Track a custom event — never include PII */
export function trackEvent(event: string, properties?: Record<string, string | number | boolean>) {
  if (!initialised) return;
  posthog.capture(event, properties);
}

/** Check a feature flag */
export function isFeatureEnabled(flagKey: string): boolean {
  if (!initialised) return false;
  return posthog.isFeatureEnabled(flagKey) ?? false;
}

export { posthog };
